// helper_functions/home2.js

import { onConfig } from "@/config";

let config = null;
onConfig((c) => {
  config = c;
});

export function formatUtcDate(utcString) {
  if (!utcString) return "-";
  const date = new Date(utcString);
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const day = String(date.getUTCDate()).padStart(2, "0");
  const hours = String(date.getUTCHours()).padStart(2, "0");
  const minutes = String(date.getUTCMinutes()).padStart(2, "0");
  const seconds = String(date.getUTCSeconds()).padStart(2, "0");
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export function displaySpeed(speed) {
  if (speed === null || speed < 2) return "-";
  return parseFloat(speed).toFixed(1) + " kn";
}
export function displayVesselSpeed(speed) {
  if (speed === null || speed < 2) return "-";
  return parseFloat(speed).toFixed(1) + " kn";
}

export function formatFuel(val) {
  const num = parseFloat(val);
  return isNaN(num) ? "0.00" : num.toFixed(2);
}

export function getFuelTotal(f) {
  if (!f) return 0;
  return (parseFloat(f.me) || 0) + (parseFloat(f.aux) || 0) + (parseFloat(f.boil) || 0);
}

export function getFuelTotalSum(f) {
  if (!f) return "0.00";
  return ["hfo", "lfo", "mgo"].reduce((acc, k) => acc + getFuelTotal(f[k]), 0).toFixed(2);
}

export function getCiiGrade(val, r) {
  if (val <= r.a_rating) return "A";
  if (val <= r.b_rating) return "B";
  if (val <= r.c_rating) return "C";
  if (val <= r.d_rating) return "D";
  return "E";
}

export function displayCii(val, v) {
  if (!val || !v.ciiRatings || !v.ciiRatings.length) return "-";
  const grade = getCiiGrade(val, v.ciiRatings[0]);
  return `${val.toFixed(2)} (${grade})`;
}

export function getCiiColor(val, v) {
  if (!val || !v.ciiRatings || !v.ciiRatings.length) return "ciiorange";
  const grade = getCiiGrade(val, v.ciiRatings[0]);
  return { A: "ciigreen", B: "ciigreen2", C: "ciiorange", D: "ciibrown" }[grade] || "ciired";
}

export function foulingClass(value) {
  const v = parseFloat(value);
  if (isNaN(v)) return "grey";
  if (v < 2) return "green";
  if (v <= 5) return "yellow";
  return "red";
}

export function cleaningClass(d) {
  if (isNaN(d)) return "grey";
  if (d <= 180) return "green";
  if (d <= 360) return "yellow";
  return "red";
}

export function dateClass(ds) {
  const date = new Date(ds);
  if (isNaN(date)) return "grey";
  let diff = (new Date() - date) / (1000 * 60 * 60);

  if (config.VUE_APP_COMPANY_ID === "4") {
    diff = (new Date(2024, 8, 25) - date) / (1000 * 60 * 60);
  }

  if (diff < 24) return "green";
  if (diff <= 72) return "yellow";
  return "red";
}

export function dataIssuesClass(count) {
  if (count === 0) return "v-chip grey";
  if (count < 3) return "v-chip yellow";
  return "v-chip red";
}
